import { API_URL, PROVIDER_PATH } from '../../environment';
  
  const ProviderService = () => {
    const _getProvider = async (category, token) => {
      const url = `${API_URL}${PROVIDER_PATH}${category}`;
  
      try {
        debugger
        const response = await fetch(url, { 
          method: 'GET',
          headers: {
          'Authorization': `Bearer ${token}`,
           'Content-Type': 'application/json'
        }, timeout: 5000 });
        const responseBody = await response.json();
  
        return responseBody;
      } catch (error) {
        console.error(error);
      };
    };
  
    return {
      // Public interface
      getProvider: _getProvider
    };
  };
  
  export default ProviderService;